<template>
  <ChartCard>
    <ChartHeader label>
      <v-skeleton-loader
        type="text"
        min-width="100%"
        height="20px"
      />
    </ChartHeader>
    <div class="w-100 d-flex align-center justify-space-between card-content">
      <DpplSkeletonLoader>
        <DpplSvg file-name="line-chart-skeleton" />
      </DpplSkeletonLoader>
      <div class="h-100 d-flex flex-column align-start justify-flex-start pt-4 legend-container">
        <div v-for="i in 3" :key="i" class="d-flex align-center justify-start mb-3 w-100">
          <DpplSkeletonLoader class="mr-2">
            <div class="colored-dot-loader" />
          </DpplSkeletonLoader>
          <v-skeleton-loader class="mr-2" type="text" height="12px" width="calc(100% - 20px)" />
        </div>
      </div>
    </div>
  </ChartCard>
</template>

<script setup>
import ChartCard from '@/components/insights/Chart/ChartCard.vue';
import ChartHeader from '@/components/insights/Chart/ChartHeader.vue';
import DpplSkeletonLoader from '@/components/datapeople/DpplSkeletonLoader.vue';
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
</script>

<style lang="less" scoped>
:deep(.v-skeleton-loader__text) {
  margin: 0 !important;
}

.card-content {
  height: calc(100% - 53px);
}

.legend-container {
  width: calc(100% - 521px);
  padding: 0 55px 0 26px;
}

.colored-dot-loader {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: fade(@grey-900, 15%);
}
</style>
